export function transformReadOriginalEmail(response) {
    return {
        data: response,
        meta: {},
    };
}
